import { AxiosError } from "axios";
import { useMutation } from "react-query";
import axiosClient from "../utils/axiosClient";

export const useSaveDocStructuringMutation = () => {
  return useMutation<
    { id: number },
    AxiosError<any>,
    {
      files: File[];
      name: string;
    }
  >(
    ({ files, name }) => {
      const body = new FormData();
      files.forEach((file) => {
        body.append("files", file);
      });
      body.append("name", name);

      return axiosClient
        .post(`/qna/docstructuring`, body, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          timeout: 2 * 60 * 1000, // 2min
        })
        .then(({ data }) => data);
    },
    {
      retry: false,
    }
  );
};
